// frontend/src/features/admin/components/ConfirmationModal.tsx
import React from 'react';
import styles from './ConfirmationModal.module.css';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CloseIcon from '@mui/icons-material/Close';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  loading?: boolean;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  loading = false,
}) => {
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <div className={styles.iconWrapper}>
            <WarningAmberIcon />
          </div>
          <button onClick={onClose} className={styles.closeButton}>
            <CloseIcon />
          </button>
        </div>
        
        <div className={styles.modalBody}>
          <h2>{title}</h2>
          <p>{message}</p>
        </div>
        
        <div className={styles.modalFooter}>
          <button 
            onClick={onClose} 
            className={`${styles.btn} ${styles.btnCancel}`}
            disabled={loading}
          >
            {cancelText}
          </button>
          <button 
            onClick={onConfirm} 
            className={`${styles.btn} ${styles.btnConfirm}`}
            disabled={loading}
          >
            {loading ? 'Processando...' : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;